// extracted by mini-css-extract-plugin
export default {"title":"GqNRai1NKz8ju5z_M588"};